import { useMutation } from '@tanstack/react-query';
import { ToastMessage } from '@utility/toast';
import { mappingErrorMessage } from '../lib/mapping-errors';
import { postRefresh } from '../lib/suggestions-api';
import { useInvalidateMapping } from './use-invalidate-mapping';

/** "Check again": recomputes the account's suggestions, then refreshes every mapping list and count. */
export function useRefreshSuggestions() {
  const invalidate = useInvalidateMapping();

  return useMutation({
    mutationFn: postRefresh,
    onError: failure => ToastMessage.error(mappingErrorMessage(failure)),
    onSettled: invalidate,
  });
}
